import React from 'react';

import { makeStyles } from '@material-ui/core';
import { CircleSwatch } from './CircleSwatch';
import KapinuaColors from '../../objects/colors/kapinuaColors';

const useStyles = makeStyles((theme) => ({
    dialogItem: {
        float: 'left',
    },
    break: {
        clear: 'both',
        width: '100%',
    },
}));

interface Props {
    handleOnChange: (hex: string, e: any) => void;
    colors: KapinuaColors | null;
    activeColor?: string;
    externalActiveColor?: string | null;
}
const KapinuaColorsList: React.FC<Props> = (props) => {
    const classes = useStyles();

    const COLORS_IN_ONE_ROW = 17;
    const { handleOnChange, colors, activeColor, externalActiveColor } = props;

    let i = 0;

    return (
        <>
            {colors &&
                colors.getItems().map((color) => {
                    i += 1;
                    return (
                        <React.Fragment key={i}>
                            <div className={classes.dialogItem}>
                                <CircleSwatch
                                    color={{
                                        color: color.getHex(),
                                        title: i.toString(),
                                    }}
                                    onClick={handleOnChange}
                                    active={
                                        (activeColor &&
                                            activeColor.toUpperCase() ===
                                                color.getHex().toUpperCase()) ||
                                        (externalActiveColor &&
                                            externalActiveColor !== null &&
                                            externalActiveColor.toUpperCase() ===
                                                color.getHex().toUpperCase())
                                    }
                                    hover={null}
                                />
                            </div>
                            {i % COLORS_IN_ONE_ROW === 0 && (
                                <div className={classes.break} />
                            )}
                        </React.Fragment>
                    );
                })}
        </>
    );
};

export default KapinuaColorsList;
